import { Flow } from '@lendica/components';
import Box from '@mui/material/Box';

export const LoadingView = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                flex: 1,
                width: '100%',
                gap: 2,
            }}
        >
            <Flow />
        </Box>
    );
};
